import axios from 'axios';
import { getRefreshToken } from '@/services/jwt.service';

export default {
  login: ({ login, password }) => {
    const data = { login, password };
    return axios.post(`${process.env.VUE_APP_BASE_API_URL}/admin/authorization`, data);
  },

  refreshAccessToken: () => {
    const data = { refresh: getRefreshToken() };
    return axios.post(`${process.env.VUE_APP_BASE_API_URL}/admin/refresh`, data);
  },

  // logout: () => {
  //   const data = new URLSearchParams();
  //   data.append('token_type_hint', 'refresh_token');
  //   data.append('client_id', clientId);
  //   data.append('client_secret', clientSecret);
  //   data.append('token', getToken());
  //   return axios.post(`${process.env.VUE_APP_AUTH_API_URL}/connect/revocation`, data, {
  //     headers: {
  //       'Content-Type': 'application/x-www-form-urlencoded',
  //     },
  //   });
  // },
};
